import { useTranslation } from "react-i18next";

import type { UserCourseLibraryExercise } from "api/schemas/UserCourse";
import { useProfileContext } from "contexts/ProfileContext";
import { Avatar } from "shared/atoms/Avatar";

import { LibraryItem } from "./LibraryItem";
import type { MediaType } from "./LibraryItem/components";

export const ExerciseLibraryItem = ({
  item,
  checked,
  showAddButton,
  onClick,
  onMoreInfoClick,
  disabled,
}: {
  item: UserCourseLibraryExercise & { new?: boolean };
  checked: boolean;
  showAddButton?: boolean;
  onClick?: (id: number) => void;
  onMoreInfoClick?: (exercise: UserCourseLibraryExercise) => void;
  disabled?: boolean;
}) => {
  const { t } = useTranslation();
  const { profile } = useProfileContext();
  const { id, title } = item.levels[0];
  const caption = item.levels.length > 0 ? `${item.levels.length} ${t("usercourse.levels")}` : undefined;
  const author = !item.creator_id
    ? undefined
    : {
        avatar: (
          <Avatar
            id={profile?.id}
            size={40}
            src={profile?.avatars?.medium || ""}
            name={`${profile?.first_name} ${profile?.last_name}`}
          />
        ),
        name: `${profile?.first_name} ${profile?.last_name}`,
      };

  const getMediaType = (): MediaType => {
    if (item.levels[0].video_file_url) return "video";
    if (item.levels[0].image_url) return "image";
    return null;
  };

  const getImage = () => {
    const imgSrc = item.levels[0].image_url || item.levels[0].video_thumbnail_file_url;
    if (!imgSrc) {
      return undefined;
    }
    return <img alt="" src={imgSrc} height="100%" />;
  };

  return (
    <LibraryItem
      caption={caption}
      author={author}
      checked={checked}
      id={id}
      image={getImage()}
      isNew={item?.new}
      itemType="exercise"
      mediaType={getMediaType()}
      tags={item.target_joints}
      title={title}
      showAddButton={showAddButton}
      onClick={onClick}
      onMoreInfoClick={onMoreInfoClick ? () => onMoreInfoClick(item) : undefined}
      disabled={disabled}
    />
  );
};
